import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { selectPermissionsObject } from '@app/store/selectors/common.selector';
import { Store } from '@ngrx/store';
import { AuthService } from '@services/auth.service';
import { debounceTime, map, mergeMap, of, withLatestFrom } from 'rxjs';

const checkPermission = (controller = '', action = '') => {
    const router = inject(Router);
    const authService = inject(AuthService);
    const store = inject(Store);
    const { pathname, search } = location;

    return authService.session.pipe(
        mergeMap((session) => {
            if (!session) {
                return authService.isAuthenticated();
            }
            return of(true);
        }),
        debounceTime(0),
        withLatestFrom(store.select(selectPermissionsObject)),
        map(([isAuthenticated, permissionsObject]) => {
            if (!isAuthenticated) {
                router.navigate(['/auth/login'], {
                    ...(!pathname.includes('/auth') &&
                        pathname !== '/' && {
                            queryParams: { ref: pathname + search },
                        }),
                });
                return false;
            }
            if (isAuthenticated && controller && action && permissionsObject) {
                const findPermission = permissionsObject[`${controller}-${action}`];
                
                if (!findPermission) {
                    router.navigate(['/error/403-access-denied']);
                    return false;
                }
            }

            return isAuthenticated;
        })
    );
};

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    const { controller, actionName } = route.data;
    return checkPermission(controller, actionName);
};

export const AuthChildGuard: CanActivateChildFn = (childRoute: ActivatedRouteSnapshot) => {
    const { controller, actionName } = childRoute.data;
    return checkPermission(controller, actionName);
};
